import { Component, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { GendersService } from '../../../services/domain/codelists/genders.service'
import { interval, Observable, Subject } from 'rxjs'
import { Gender } from '../../../models/gender'
import { WorkerAvailability } from '../../../models/workerAvailability'
import { ModalController } from '@ionic/angular'
import { Assistance } from '../../../models/assistance'
import { AssistanceService } from '../../../services/domain/assistance/assistance.service'
import { WorkerSelectComponent } from '../worker-select/components/worker-select/worker-select.component'
import { takeUntil } from 'rxjs/operators'
import { IRecommendedAssistantsFilter } from '../../assistance/assistance-editor/recommended-assistants-filter'
import { DateRange } from '../../../services/date-utils.service'
import { PrimeNgToastService } from '../../../services/prime-ng-toast/prime-ng-toast.service'

@Component({
  selector: 'app-worker-select-for-modal',
  templateUrl: './worker-select-for-modal.component.html',
  styleUrls: ['./worker-select-for-modal.component.scss'],
  standalone: true,
  imports: [WorkerSelectComponent],
})
export class WorkerSelectForModalComponent implements OnInit, OnDestroy {
  private genderService = inject(GendersService)
  private modalCtrl = inject(ModalController)
  private assistanceService = inject(AssistanceService)
  private toaster = inject(PrimeNgToastService)

  @Input() assistanceURID: string
  @Input() assistanceRange: DateRange
  @Input() filterOverrides: Partial<IRecommendedAssistantsFilter> = {}

  @ViewChild('workerSelect')
  workerSelectComponent: WorkerSelectComponent

  genders$: Observable<Gender[]>
  unsubscribe$$ = new Subject<void>()
  private TAG = 'WorkerSelectForModalComponent'
  assistantChanges = false
  private closeAllowed = true

  ngOnInit() {
    this.genders$ = this.genderService.getAllWithAddedEmptyGender()

    // After the internal component closes, wait for some time and then dismiss this modal. Wait for any pending operations to finish.
    interval(300)
      .pipe(takeUntil(this.unsubscribe$$))
      .subscribe((_) => {
        if (this.workerSelectComponent.isClosed() && this.closeAllowed) {
          this.dismissModal()
          console.log(this.TAG, 'closeAttempt successful')
        }
      })
  }

  async updateAssistants(event: { assistance: Assistance; availabilities: WorkerAvailability[] }) {
    this.closeAllowed = false
    console.log(this.TAG, 'updateAssistants', event)
    const resultAssignments = await this.assistanceService.updateAvailabilitiesOnAssistance(
      event.assistance,
      event.availabilities,
    )
    if (resultAssignments.length) {
      this.assistanceURID = String(resultAssignments[0].assistanceId)
    }
    console.log(this.TAG, 'updateAssistants incoming assignments', resultAssignments)
    this.dismissModal()
    this.closeAllowed = true
  }
  async removeAssistants(event: { assistanceId: number; assistance: Assistance }) {
    this.closeAllowed = false
    console.log(this.TAG, 'removeAssistants', event)
    try {
      await this.assistanceService.removeAvailabilitiesFromAssistance(event.assistance)
    } catch (e) {
      this.toaster.displayCustomToast('error', 'TOAST.ERROR')
      console.error(this.TAG, 'removeAssistants', e)
    }
    this.dismissModal()
    this.closeAllowed = true
  }

  onClose(withChanges: boolean) {
    if (withChanges) {
      console.log(this.TAG, 'onClose')
      this.assistantChanges = true
    } else {
      this.assistantChanges = false
      console.log(this.TAG, 'onCloseWithoutChanges')
    }
  }

  ngOnDestroy(): void {
    console.log(this.TAG, 'onDestroy')
    this.unsubscribe$$.next()
    this.unsubscribe$$.complete()
  }

  private dismissModal() {
    this.modalCtrl.dismiss({
      changes: this.assistantChanges,
      assistanceURID: this.assistanceURID,
    })
  }
}
